import React, { useState } from "react";
import "../style.css";

const experiencesData = [
  {
    id: 1,
    title: "Serene Guptar Ghat",
    city: "Ayodhya",
    description:
      "Guptar Ghat on the River Saryu is sacred as the place where Lord Rama is believed to have taken Jal Samadhi, ending his earthly journey.",
    image: "https://s7ap1.scene7.com/is/image/incredibleindia/2-guptar-ghat-ayodhya-uttar-pradesh-attr-hero?qlt=82&ts=1726649747726"
  },
  {
    id: 2,
    title: "Majestic Allahabad Fort",
    city: "Prayagraj",
    description:
      "The Allahabad Fort, built in 1583 by Emperor Akbar, stands along the Yamuna near Triveni Sangam.",
    image: "https://cdn1.tripoto.com/media/filter/nl/img/2380291/Image/1702019603_akbar_fort_allahabad.jpg.webp"
  },
  {
    id: 3,
    title: "Ancient Barabar Caves",
    city: "Gaya",
    description:
      "Barabar Caves are India’s oldest rock-cut caves, dating back to the Mauryan period.",
    image: "https://static.toiimg.com/thumb/msid-52430760,width=1200,height=900/52430760.jpg"
  },
  {
    id: 4,
    title: "Kashi Vishwanath Temple",
    city: "Varanasi",
    description:
      "Among the most sacred Hindu shrines dedicated to Lord Shiva, located along the holy Ganga.",
    image: "https://www.amritara.co.in/_next/image?url=https%3A%2F%2Famritaracms.cinuniverse.com%2Fimg%2Fpost%2Fimage_2025-03-12-07-44-13_67d13b4d87593.jpg&w=1920&q=75"
  },
  {
    id: 5,
    title: "Kamadgiri Hill Parikrama",
    city: "Chitrakoot",
    description:
      "A spiritually powerful forested hill where devotees perform sacred parikrama.",
    image: "https://iskconchitrakoot.com/img/ckt/kamadgiri.jpeg"
  },
  {
    id: 6,
    title: "Kanak Bhawan Temple",
    city: "Ayodhya",
    description:
      "Dedicated to Lord Rama and Goddess Sita, believed to be gifted by Queen Kaikeyi.",
    image: "https://upload.wikimedia.org/wikipedia/commons/3/31/Kanak_Bhawan.jpg"
  },
  {
    id: 7,
    title: "Ramnagar Fort & Museum",
    city: "Varanasi",
    description:
      "18th-century fort housing royal artifacts, manuscripts, and vintage collections.",
    image: "https://upload.wikimedia.org/wikipedia/commons/8/89/Entrance_area_of_Ramnagar_Fort.jpg"
  },
  {
    id: 8,
    title: "Anand Bhavan Museum",
    city: "Prayagraj",
    description:
      "Historic home of the Nehru family, showcasing India’s freedom struggle.",
    image: "https://api.theindia.co.in/storage/image/places/banner/anand-bhawan-285895.jpg"
  },
  {
    id: 9,
    title: "Sacred Bodhi Tree",
    city: "Gaya",
    description:
      "A direct descendant of the tree under which Buddha attained enlightenment.",
    image: "https://a-z-animals.com/media/2023/12/shutterstock-1729348537-huge-licensed-scaled-1024x657.jpg"
  }
];

const categories = [
  "All",
  "Varanasi",
  "Ayodhya",
  "Prayagraj",
  "Gaya",
  "Chitrakoot"
];

const CuratedExperiences = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredData =
    activeCategory === "All"
      ? experiencesData
      : experiencesData.filter(item => item.city === activeCategory);

  return (
    <section className="curated-section">
      <div className="curated-container">

        {/* Header */}
        <div className="curated-header">
          <h2>Curated Experiences</h2>
          <p>
            Explore Sacred <span>Destinations.</span>
          </p>
        </div>

        {/* Filters */}
        <div className="curated-filters">
          {categories.map(cat => (
            <button
              key={cat}
              className={activeCategory === cat ? "filter-btn active" : "filter-btn"}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Cards */}
        <div className="curated-grid">
          {filteredData.map(item => (
            <div className="curated-card" key={item.id}>
              <img src={item.image} alt={item.title} />
              <div className="curated-card-content">
                <span className="city-tag">{item.city}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <button className="view-btn">View Details</button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CuratedExperiences;
